import React from 'react'
import { Paper, Table, Typography } from '@material-ui/core'

import { BigCalendarHead, BigCalendarBody, BigCalendarFooter } from './components'


export const BigCalendarBase = ({ classes, routeId }) =>
  routeId
    ? (
      <Paper>
        <Table>
          <BigCalendarHead />
          <BigCalendarBody routeId={routeId} />
          <BigCalendarFooter routeId={routeId} />
        </Table>
      </Paper>
    )
    : (
      <Typography
        variant='h4'
        className={classes.placeholder}
      >
        Оберіть маршрут
      </Typography>
    )


// WEBPACK FOOTER //
// ./src/components/BigCalendar/BigCalendar.js